export default __webpack_public_path__ + "static/media/down-arrow--white.8a7d1076.svg";